import { render, staticRenderFns } from "./reminderandnotification.vue?vue&type=template&id=6afb0cf1&scoped=true&"
import script from "./reminderandnotification.vue?vue&type=script&lang=js&"
export * from "./reminderandnotification.vue?vue&type=script&lang=js&"
import style0 from "./reminderandnotification.vue?vue&type=style&index=0&id=6afb0cf1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afb0cf1",
  null
  
)

export default component.exports